var map = {
	"./decidim/avatar-multiuser.png": 80354,
	"./decidim/brands/facebook.svg": 25876,
	"./decidim/brands/google.svg": 90093,
	"./decidim/brands/twitter-x.svg": 83678,
	"./decidim/cc-badge.png": 19292,
	"./decidim/decidim-logo.svg": 38896,
	"./decidim/default-avatar.svg": 7208,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 97364,
	"./decidim/icons.svg": 59779,
	"./decidim/pattern.png": 29076,
	"./decidim/placeholder-card-g.svg": 8481,
	"./decidim/placeholder-card-l.svg": 92394,
	"./decidim/placeholder.jpg": 98489,
	"./decidim/remixicon.symbol.svg": 6829,
	"./decidim/vendor/social-share-button/douban.svg": 6044,
	"./decidim/vendor/social-share-button/email.svg": 77177,
	"./decidim/vendor/social-share-button/facebook.svg": 55535,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 75857,
	"./decidim/vendor/social-share-button/hacker_news.svg": 54777,
	"./decidim/vendor/social-share-button/linkedin.svg": 39609,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 88346,
	"./decidim/vendor/social-share-button/pinterest.svg": 63103,
	"./decidim/vendor/social-share-button/reddit.svg": 88163,
	"./decidim/vendor/social-share-button/telegram.svg": 91606,
	"./decidim/vendor/social-share-button/tumblr.svg": 81749,
	"./decidim/vendor/social-share-button/twitter.svg": 18440,
	"./decidim/vendor/social-share-button/vkontakte.svg": 84966,
	"./decidim/vendor/social-share-button/wechat.svg": 36097,
	"./decidim/vendor/social-share-button/whatsapp.svg": 77513,
	"./decidim/vendor/social-share-button/x.svg": 47745,
	"./decidim/vendor/social-share-button/xing.svg": 48271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3191;